import { useQuery } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { ROOT_DOCUMENTS_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';

export function useInternalDocuments(dispensaryId: string) {
  const dispensariesApi = new DispensariesApi();
  const { userBankId } = useUser();

  const { data: internalDocuments, isLoading: isLoadingInternalDocuments } = useQuery({
    enabled: !!dispensaryId.length || !!userBankId,
    queryKey: [ROOT_DOCUMENTS_KEY, userBankId, dispensaryId],
    queryFn: () => dispensariesApi.getInternalDocuments(userBankId, dispensaryId)
  });

  return { internalDocuments, isLoadingInternalDocuments };
}
